// Header links are routes (as before): /approach, /capabilities ... Each route scrolls to a section of the page.
export const navLinks = [
  { label: "Our Approach", to: "/approach" },
  { label: "Capabilities", to: "/capabilities" },
  { label: "Transformation Stories", to: "/stories" },
  { label: "GAiNSS", to: "/gainss" },
];

// route path -> id of the section it scrolls to (a path with no entry scrolls to the section with the same id)
export const sectionMap = {
  approach: "transformation-assurance",
  capabilities: "lifecycle",
  stories: "ai-insights",
  gainss: "top",
  contact: "demo",
  about: "about",
};

export const loginLink = "https://app.gainss.ai/login";

export const mapFeed = ["User Stories", "Test Cases", "Test Automation", "Test Executions", "Defects"];

export const mapOutput = ["Risk visibility", "Schedule concerns", "Quality signals", "Process improvements"];

export const lifecycle = [
  { title: "User Stories", text: "Capture the intended change and the requirements that guide delivery." },
  { title: "Test Cases", text: "Define validation around the story, its behaviour and the risks to cover." },
  { title: "Test Automation", text: "Bring repeatable automated validation into the engineering workflow." },
  { title: "Test Executions", text: "Capture execution evidence across manual and automated testing." },
  { title: "Defects", text: "Connect findings to the quality concerns and actions that need attention." },
];

export const lenses = [
  {
    title: "Risk visibility",
    text: "Bring coverage, execution and defect evidence into view. Identify where confidence is limited and what needs investigation.",
    question: "What remains uncertain before we move forward?",
  },
  {
    title: "Schedule visibility",
    text: "Review progress across lifecycle work and surface slippage that could affect delivery commitments.",
    question: "Where is delivery losing momentum?",
  },
  {
    title: "Quality visibility",
    text: "Make validation results and defect concerns visible alongside the work being delivered.",
    question: "What does the evidence say about readiness?",
  },
];

export const dashboardTabs = [
  {
    id: "risk",
    label: "Risk",
    title: "Where does confidence need attention?",
    text: "Bring lifecycle signals together to highlight areas that need investigation before they become larger delivery problems.",
    signals: ["Story coverage", "Execution evidence", "Open defects"],
    finding: "Coverage may be insufficient for a priority story.",
    findingText: "Review linked validation and unresolved findings before treating the story as ready.",
    action: "Validate the finding against the delivery context.",
  },
  {
    id: "schedule",
    label: "Schedule",
    title: "Where is progress diverging from the plan?",
    text: "Use engineering lifecycle dashboards to make schedule slippage and delivery constraints visible.",
    signals: ["Planned progress", "Execution progress", "Defect resolution"],
    finding: "Validation work may be delaying a delivery milestone.",
    findingText: "Review incomplete execution, dependencies and defect resolution with the team responsible for the milestone.",
    action: "Agree the next action and review point.",
  },
  {
    id: "quality",
    label: "Quality",
    title: "What does the evidence say about readiness?",
    text: "Review execution results and defect signals alongside coverage to identify quality concerns.",
    signals: ["Test outcomes", "Defect trends", "Validation gaps"],
    finding: "A completed test run may still leave unresolved quality risk.",
    findingText: "Examine failures, open defects and untested areas before making a release decision.",
    action: "Record the decision and remaining risk.",
  },
];

export const insightSteps = [
  {
    tag: "01 / UNDERSTAND",
    title: "Analyze lifecycle evidence",
    text: "Use the captured records and intelligence metrics to review how work is progressing across the engineering process.",
  },
  {
    tag: "02 / IDENTIFY",
    title: "Surface improvement opportunities",
    text: "Highlight process gaps, recurring concerns and areas where effort could be better focused.",
  },
  {
    tag: "03 / ACT",
    title: "Review and improve",
    text: "Translate recommendations into team decisions and track the relevant measures as the process changes.",
  },
];

export const people = [
  {
    title: "Engineering leaders",
    text: "Review delivery risk, schedule slippage and quality concerns with a view of the evidence behind them.",
  },
  {
    title: "Delivery teams",
    text: "See where the engineering process needs attention and focus conversations on the next decision or improvement.",
  },
  {
    title: "Quality teams",
    text: "Connect test cases, automation, executions and defects to strengthen the basis for validation and readiness discussions.",
  },
];

export const fitSteps = [
  { title: "Assess", text: "Use lifecycle evidence to understand delivery health, process gaps and areas of risk." },
  { title: "Transform", text: "Keep stories, validation and execution evidence connected as change progresses." },
  { title: "Assure", text: "Bring quality concerns and unresolved risk into readiness and release discussions." },
  { title: "Optimize", text: "Use AI-assisted findings and engineering metrics to identify and review efficiency improvements." },
];

export const footerGainssLinks = [
  { label: "Engineering Lifecycle", to: "/capabilities" },
  { label: "AI-assisted Insights", to: "/stories" },
  { label: "Request a Demo", to: "/contact" },
];

export const footerExploreLinks = [
  { label: "Home", to: "/" },
  { label: "Our Approach", to: "/approach" },
  { label: "GAiNSS", to: "/gainss" },
];

export const aboutText =
  "GTEN Technologies is an AI-native Transformation Assurance company. GAiNSS is our intelligence platform for transformations, connecting engineering evidence to informed decisions and improvement.";